import 'magnific-popup';

$('.js-picture-remove').on('click', event => {
  const id = $(event.target).data('id');
  createRemovePicturePopUp(id);
});

const createRemovePicturePopUp = (pictureId) =>{
  $.ajax({
    url: '/popup_picture_remove/' + pictureId,
    type: 'GET',
    success: function(html) {
      $('#popup').html(html);

      $.magnificPopup.open({
        items: {src: '#popup'},
        type: 'inline',
        fixedContentPos: true,
      }, 0);

      $(document).on('click', '.back', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
      });
    },
    error: function(e) {
      console.error(e);
      alert('ポップアップの作成に失敗しました');
    }
  });
};
